.disabled {
  opacity: 0.5;
  pointer-events: none;
}

gz-text + gz-form-field {
  margin-top: calc(var(--spacer) * 2.5);
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width {
    padding-right: 20px;
  }

  gz-text {
    width: fit-content;
    padding: 5px 20px 20px 20px;
  }

  gz-text + gz-form-field {
    margin-top: 0;
  }
}

#maxSizeLabel {
  --font-family: var(--font-family-secondary);
}
